module.exports = __webpack_public_path__ + "img/axXez_Logo.506a44d3.svg";